import type { Alert } from '@/entities/alert';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

import { DetailsLinkButton } from './details-link-button';
import { SystemLogsLinkButton } from './system-logs-link-button';

export type AlertActionsProps = {
  alert?: Alert;
};

export function AlertActions({ alert }: AlertActionsProps) {
  const featureFlag = useFeatureFlag();

  if (alert) {
    return (
      <div className="flex gap-2">
        <DetailsLinkButton alert={alert} />
        {featureFlag('systemLogs') && <SystemLogsLinkButton alert={alert} />}
      </div>
    );
  }

  return null;
}
